// extracted by mini-css-extract-plugin
var _1 = "RegisterWithProvisionView-module__emailText--zJdtt";
export { _1 as "emailText" }
